import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import accredhospilogo from '../../assets/images/accredhospi-logo.png'
import { connect } from 'react-redux';
import { SET_INFOS } from '../../state/action/action';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
		maxWidth: 350
  },
  gridMain: {
    display: 'flex',
		flexDirection: 'column',
    alignItems: 'center',
		justifyItems: 'center',
		marginTop: theme.spacing(2)
  },
	textField: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
	},
	btn: {
      '& .MuiButton-label' :{
          textTransform :'none'
      }
  }
}));


function Informations({referentiel, information, dispatch}) {
	// state
	const [infos, setInfos] = useState(information);

	const classes = useStyles()

	useEffect(() => {
		setInfosR(infos)
	}, [infos])
	

	const setInfosR = (value) => {
		const action = {
			type: SET_INFOS,
			value
		};
		dispatch(action)
	}

	const handleChange = (e, type) => {
		let value = e.target.value;

		switch (type) {
			case 'hname':
				setInfos((prev) => ({...prev,	hname: value}));
				break;

			case 'hmail':
				setInfos((prev) => ({...prev, hmail: value}));
				break;
			
			case 'hautorisation':
				setInfos((prev) => ({...prev, hautorisation: value}));
				break;
			
			case 'hnum':
				setInfos((prev) => ({...prev, hnum: value}));
				break;
			

			case 'username':
				setInfos((prev) => ({...prev, username: value}));
				break;
			
			case 'usermail':
				setInfos((prev) => ({...prev, usermail: value}));
				break;
			
			case 'fonction':
				setInfos((prev) => ({...prev, fonction: value}));
				break;

			case 'userstatus':
				setInfos((prev) => ({...prev, userstatus: value}));
				break;
					
			default:
				break;
		}
	}

  return (
	<div className={classes.root}>
		<Grid container direction='column' alignItems='center' justify='center'>
			<Grid container item direction='column' alignItems='center' justify='center' style={{width: '350px', height: '350px',}} >
				<img src={accredhospilogo} alt='Logo AccredHospi' style={{width: '334px', height: '279px'}} />
			</Grid>
		</Grid>
		<Typography align='center'>
			Veuillez nous donner vos informations générales en remplissant les champs ci après 
		</Typography>
		<Grid container item  className={classes.gridMain} spacing={3}>
			<TextField value={infos.username} onChange={(e) => handleChange(e, 'username')} className={classes.textField} color='secondary' fullWidth={true} type="text" size='small' id="username" label="Nom et prénoms" variant="outlined" />
			<TextField value={infos.usermail} onChange={(e) => handleChange(e, 'usermail')} className={classes.textField} color='secondary' fullWidth={true} type="mail" size='small' id="usermail" label="Votre mail" variant="outlined" />
			<TextField value={infos.fonction} onChange={(e) => handleChange(e, 'fonction')} className={classes.textField} color='secondary' fullWidth={true} type="text" size='small' id="fonction" label="Votre fonction" variant="outlined" />
			<TextField value={infos.hname} onChange={(e) => handleChange(e, 'hname')} className={classes.textField}  color='primary' fullWidth={true} type="text" size='small' id="hospitalname" label="Nom de l'hôpital" variant="outlined" />
			<TextField value={infos.hmail} onChange={(e) => handleChange(e, 'hmail')} className={classes.textField} color='primary' fullWidth={true} type="mail" size='small' id="hospitalmail" label="Email de l'hôpital" variant="outlined" />
			<TextField value={infos.hautorisation} onChange={(e) => handleChange(e, 'hautorisation')} className={classes.textField} color='primary' fullWidth={true} type="mail" size='small' id="hospitalaut" label="Autorisations" variant="outlined" />
			<TextField value={infos.hnum} onChange={(e) => handleChange(e, 'hnum')} className={classes.textField} color='primary' fullWidth={true} type="mail" size='small' id="hospitalnum" label="Numéro de l’hôpital " variant="outlined" />
			<Typography >
				Vous faites l’évaluation dans le cadre:
			</Typography>
			<RadioGroup row aria-label="sous_criteres" name="sous_criteres" value={infos.userstatus} onChange={(e) => handleChange(e, 'userstatus')}>
				<FormControlLabel value='1' control={<Radio color='secondary' />} label="Audit interne" labelPlacement="end" />
				<FormControlLabel value='0' control={<Radio color='secondary' />} label="Evaluation externe"  labelPlacement="start"/>
  		</RadioGroup>
			
			<Link to='/domaine/1/1/1/1.a' style={{ textDecoration: 'none', color: 'inherit', marginTop: '15%', marginBottom: '15%' }}>
				<Button variant="outlined" color="primary" className={classes.btn}>
					Commencer
				</Button>
			</Link>
		</Grid>
	</div>
	)
}

const mapStateToProps = (state) => {
	return {
		information: state.setInfosReducer.infos
	}
}

export default connect(mapStateToProps)(Informations);
